import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatError } from '@angular/material/input';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'bt-field-errors',
  templateUrl: './field-errors.component.html',
  styleUrls: ['./field-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatError]
})
export class FieldErrorsComponent {
  @Input() control: UntypedFormControl;

  constructor(private translate: TranslateService) {
  }

  getErrors(): string[] {
    if (this.control && this.control.touched && this.control.errors) {
      const errors = this.control.errors;
      const keys = Object.keys(this.control.errors);

      if (errors.minlength && errors.minlength.requiredLength) {
        return [
          this.translate.instant('validation.error.minLength', {
            length: errors.minlength.requiredLength
          })
        ];
      }
      else if (keys.length) {
        const errorKey = keys[0];
        const translatedMessage = this.translate.instant(
          `validation.error.${errorKey}`
        );

        // Check if the translation exists
        if (translatedMessage !== `validation.error.${errorKey}`) {
          return [translatedMessage];
        }
        else if (errors[errorKey].msg) {
          return [errors[errorKey].msg]; // Fallback to the original msg
        }
      }
      else {
        return keys;
      }
    }
    return [];
  }
}
